import { useMediaQuery } from './useMediaQuery';
import { MEDIA_QUERIES } from 'constants/breakpoints';

/**
 * Hook to detect if the viewport is mobile size (≤1023px)
 * @returns {boolean} true if viewport is mobile size
 */
export const useIsMobile = () => useMediaQuery(MEDIA_QUERIES.isMobile);

/**
 * Hook to detect if the viewport is desktop size (>1023px)
 * @returns {boolean} true if viewport is desktop size
 */
export const useIsDesktop = () => useMediaQuery(MEDIA_QUERIES.isDesktop);

export default useIsMobile;
